export default {
  background: '#f5f8fb',
  fontFamily: 'monospace',
  headerBgColor: '#0088cc',
  headerFontColor: '#ffffff',
  headerFontSize: '16px',
  botBubbleColor: '#0088cc',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a'
};
